import { IconAward, IconBook, IconChartBar, IconFileText, IconHome, IconRoute, IconSquareCheck } from '@tabler/icons-react';
import type { NavGroup, NavItem } from '@hana/shell';
import { LEARNERS } from './data/courses';

// Menu chung của Hub cho HANA Edu (NAVK.sp.edu · board Mint-Training, QĐ anh David 01/Nov 12:33):
// lớp CỦA TÔI = các app học · lớp QUẢN LÝ (Giao khoá · Hoàn thành · Kết quả thi) chỉ HR / trưởng phòng, ẩn khi noperm.

const MINE: readonly NavItem[] = [
  { key: 'home', label: 'Trang chủ', to: '/edu', icon: IconHome },
  { key: 'mine', label: 'Khoá học', to: '/edu/courses', icon: IconBook, n: 3 },
  { key: 'path', label: 'Lộ trình', to: '/edu/path', icon: IconRoute },
  { key: 'exam', label: 'Thi', to: '/edu/exams', icon: IconSquareCheck, n: 1 },
  { key: 'cert', label: 'Chứng chỉ', to: '/edu/certs', icon: IconAward, n: 1 },
  { key: 'lib', label: 'Thư viện', to: '/edu/library', icon: IconFileText },
];

const MGR: readonly NavGroup[] = [
  {
    key: 'mgr', label: 'Quản lý đào tạo', icon: IconChartBar, section: 'QUẢN LÝ',
    items: [
      { key: 'mgr-assign', label: 'Giao khoá', to: '/edu/manage' },
      { key: 'mgr-done', label: 'Hoàn thành', to: '/edu/manage/done' },
      { key: 'mgr-score', label: 'Kết quả thi', to: '/edu/manage/score' },
    ],
  },
];

/** Menu theo người xem (`?viewer=`, mặc định DAVID): như board `canMgr = me.mgr && pstate !== 'noperm'`; noperm bỏ số đếm. */
export function eduNav(search: string): { top: NavItem[]; nav: NavGroup[] } {
  const p = new URLSearchParams(search);
  const v = p.get('viewer');
  const mgr = (v && v in LEARNERS ? LEARNERS[v as keyof typeof LEARNERS] : LEARNERS.DAVID).manager;
  const noperm = p.get('state') === 'noperm';
  return {
    top: MINE.map((i) => (noperm ? { ...i, n: undefined } : { ...i })),
    nav: mgr && !noperm ? MGR.map((g) => ({ ...g, items: [...g.items] })) : [],
  };
}

export const currentSearch = () => (typeof location === 'undefined' ? '' : location.search);
